import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AuthProvider from "./auth/AuthProvider";
import * as serviceWorker from "./serviceWorker";
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "./setupCompatibility";
import "antd/dist/reset.css";
import "./index.css";

// Get the root element
const container = document.getElementById("root");

// Ensure the container exists before creating the root
if (container) {
  // Create a React root for concurrent rendering
  const root = createRoot(container);

  // Render the App component wrapped with providers
  root.render(
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  );
}

// Unregister the service worker to disable offline caching (change to register() for enabling it)
serviceWorker.unregister();